import { logger } from "@/modules/logger";
import { objectModule } from "@/modules/object";

export const newBlob = (blobParts?: BlobPart[], options?: BlobPropertyBag) => {
  try {
    return new Blob(blobParts, options);
  } catch (error) {
    logger.error({
      message: "[AppStoreAudioCaptureStore] Creating Blob",
      info: { error: objectModule.safeErrorAsJson(error as Error) },
    });
  }
  return null;
};

export const stopMediaRecorder = (mediaRecorder?: MediaRecorder | null) => {
  if (!mediaRecorder) return;
  try {
    if (mediaRecorder.state !== "inactive") mediaRecorder.stop();
  } catch (error) {
    logger.error({
      message: "[AppStoreAudioCaptureStore] Stopping MediaRecorder",
      info: { error: objectModule.safeErrorAsJson(error as Error) },
    });
  }
};

export const stopMediaStream = (mediaStream?: MediaStream | null) => {
  if (!mediaStream) return;
  try {
    mediaStream.getTracks().forEach(track => {
      track.stop();
      mediaStream.removeTrack(track);
    });
  } catch (error) {
    logger.error({
      message: "[AppStoreAudioCaptureStore] Stopping MediaStream",
      info: { error: objectModule.safeErrorAsJson(error as Error) },
    });
  }
};

export const suspendAudioContext = async (audioContext?: AudioContext | null) => {
  if (audioContext?.state !== "running") return;
  try {
    await audioContext.suspend();
  } catch (error) {
    logger.error({
      message: "[AppStoreAudioCaptureStore] Suspending AudioContext",
      info: { error: objectModule.safeErrorAsJson(error as Error) },
    });
  }
};

export const disconnectAudioNode = (
  audioNode?: AudioNode | null,
  destinationNode?: AudioNode | null
) => {
  if (!audioNode) return;
  try {
    if (destinationNode) {
      audioNode.disconnect(destinationNode);
    } else {
      audioNode.disconnect();
    }
  } catch (error) {
    logger.error({
      message: "[AppStoreAudioCaptureStore] Disconnecting AudioNode",
      info: { error: objectModule.safeErrorAsJson(error as Error) },
    });
  }
};

export const closeAudioContext = (audioContext?: AudioContext | null) => {
  if (!audioContext) return;
  try {
    if (audioContext.state !== "closed") audioContext.close();
  } catch (error) {
    logger.error({
      message: "[AppStoreAudioCaptureStore] Closing AudioContext",
      info: { error: objectModule.safeErrorAsJson(error as Error) },
    });
  }
};

export const closeWebSocket = (webSocket?: WebSocket | null) => {
  if (!webSocket) return;
  try {
    webSocket.close();
  } catch (error) {
    logger.error({
      message: "[AppStoreAudioCaptureStore] Closing WebSocket",
      info: { error: objectModule.safeErrorAsJson(error as Error) },
    });
  }
};
